import NFAnalytics from "shared/helpers/analytics/NFAnalytics";
import { PDP_EVENTS } from 'shared/helpers/analytics/constants/pdpEvents';
import { TRACK_TYPE } from 'shared/helpers/analytics/constants';

export const onViewBagClick = () => {
    NFAnalytics.updateDatalayerBeforeNext({ isViewedFromNudge: 'yes' });

};

export const onNudgeContinueClick = () => {
  NFAnalytics.track({
    event: PDP_EVENTS.NUDGE_CONTINUE_CLICK,
    type: TRACK_TYPE.EVENT,
  });
};
